"use strict";
var Observable_1 = require('../../Observable');
var reduce_1 = require('../../operator/reduce');
Observable_1.Observable.prototype.reduce = reduce_1.reduce;
//# sourceMappingURL=reduce.js.map


//////////////////
// WEBPACK FOOTER
// /root/anvel/~/rxjs/add/operator/reduce.js
// module id = ../../../../rxjs/add/operator/reduce.js
// module chunks = 4